import { Component, OnInit, OnChanges, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { CertificationVariantVersionInterface } from 'src/app/model/certifications/certification-variant-version-interface';
import { CommonFeatureEntryInterface } from 'src/app/model/commonFeature/common-feature-entry-interface';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { DataType } from 'src/app/model/data-type.enum';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { VariantVersionInterface } from 'src/app/model/products/variant-version-interface';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';

@Component({
    selector: 'app-product-summary',
    templateUrl: './product-summary.component.html',
    styleUrls: ['./product-summary.component.scss'],
    standalone: false
})
export class ProductSummaryComponent implements OnInit, OnChanges {

  @Input() product: ProductInterface;
  @Input() productFeatures?: string[];
  @Input() selectedCommonFeatures?: ProductCommonFeatureInterface[];
  @Input() showPTG: Boolean = true;

  public groupedSelectedFeaturesArray: { featureId: number; featureName: string; entries: CommonFeatureEntryInterface[] }[]; 
  public dataTypeEnum = DataType;

  constructor(public organisationService: OrganisationService,
    public productService: ProductService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedCommonFeatures']) {
      this.updateGroupedSelectedFeatures();
    }
  }

  getImagePath(id: string): string {
    return `/proxy/api/v0/fileservice/file/${id}`;
  }

  private updateGroupedSelectedFeatures(): void {
    const groups: { featureId: number; featureName: string; entries: CommonFeatureEntryInterface[] }[] = [];

    this.selectedCommonFeatures.forEach(selected => {
      let group = groups.find(g => g.featureId === selected.feature.id);
      if (group) {
        group.entries.push(selected.entry);
      } else {
        groups.push({
          featureId: selected.feature.id,
          featureName: selected.feature.name,
          entries: [selected.entry]
        });
      }
    });

    this.groupedSelectedFeaturesArray = groups;
  }

}
